import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import routes from '../../../../../../components/Routes/routingMap';
import { formatValuesLoad } from '../forms/index/values';
import RegisterBaseView from '../register/RegisterBseView';
import { Creators as bseActions } from '../../../../../../../domain/useCases/bse/getFormBseUseCase';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as bseActivateOrderActions } from '../../../../../../../domain/useCases/bse/activatePayOrderUseCase';
import { Creators as processActions } from '../../../../../../../domain/useCases/bse/processBseUseCase';
import { Creators as procedureStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as stateBseActions } from '../../../../../../../domain/useCases/bse/getStateBseUseCase';
import { Creators as deleteActions } from '../../../../../../../domain/useCases/bse/deleteFileBseUseCase';
import { Creators as uploadActions } from '../../../../../../../domain/useCases/bse/uploadBseDocument';
import { Creators as downloadActions } from '../../../../../../../domain/useCases/dropBox/getUrlDocumentUseCase';
import constants from '../../../../constants';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

const ProgressBseController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [xcheckpointCalled, setXcheckpointCalled] = useState(false);
  const arrStepsProgress = JSON.parse(JSON.stringify(constants.arrStepsBSE));
  const { data: dataStateBse } = useSelector((state: any) => state.getStateBse);
  const { isLoading: isLoadingUpdateFiles } = useSelector(
    (state: any) => state.uploadDocumentBse
  );

  let objStateBse = {
    commentary: '',
    dateRequest: 0,
    dateFinalized: 0,
    expirationDate: 0,
    discount: '',
    isLastAttempt: false
  };

  if (dataStateBse) {
    const {
      commentary,
      dateRequest, // anterior --> sendDate: dateRequest,
      dateFinalized,
      discount,
      expirationDate,
      isLastAttempt
    } = dataStateBse;
    objStateBse = {
      commentary,
      dateRequest: dateRequest + new Date().getTimezoneOffset() * 60 * 1000,
      dateFinalized,
      discount,
      expirationDate,
      isLastAttempt
    };
  }

  const { isLoading: loadingProcessBSE, isSuccess: isSuccessProcesBSE } =
    useSelector((state: any) => state.processBse);

  const {
    isLoading: loadingActivatePayOrder,
    isSuccess: isSuccessActivatePay
  } = useSelector((state: any) => state.activatePayOrder);

  const {
    isLoading: loadingFormBSE,
    data: formBse,
    documents: documentsBse,
    dbToken: tokenDB
  } = useSelector((state: any) => state.getFormBse);

  const {
    procedure: procedureStatus,
    request,
    isLoading
  } = useSelector((state: any) => state.procedureStudentStatus);
  const procedure = useSelector(
    (state: any) => state.procedureInformation?.procedure
  );

  useEffect(() => {
    if (!loadingFormBSE && !isLoading && !procedureStatus) {
      history.push('/tramites');
    }
  }, [isLoading, procedureStatus]);

  const validateForms = (fields: any) => {
    const isEmpty = [...Object.values(fields)].find(
      (field) => Boolean(field) === true
    );

    if (isEmpty === undefined) return undefined;

    if (fields.savingsPosee === 'No') {
      delete fields.savingsMonto;
      delete fields.savingsEntidad;
    }
    if (fields.debtsPosee === 'No') {
      delete fields.debtsTipo;
      delete fields.debtsPagoMensual;
      delete fields.debtsMonto;
      delete fields.debtsFechaFin;
      delete fields.debtsEntidad;
    }
    delete fields.additionalInformation;
    delete fields.fullNameFather;
    delete fields.fullNameMother;
    delete fields.phoneFather;
    delete fields.phoneMother;
    delete fields.dniFather;
    delete fields.dniMother;
    delete fields.fullNameRepresentative;
    delete fields.dniRepresentative;
    delete fields.phoneRepresentative;
    const existsEmptyField = [...Object.values(fields)].find(
      (field) => Boolean(field) === false
    );
    return typeof existsEmptyField === 'undefined';
  };

  const {
    formData,
    // formFamily,
    formIncome,
    formExpenses,
    formSavingsAndDebts,
    formAdditionalInformation,
    formHealth,
    formLivingPlace
  } = formatValuesLoad(formBse);

  const idRequest = request?.id || 0;

  const formIsCompleted =
    idRequest > 0
      ? validateForms({
          ...formData,
          // ...formFamily,
          ...formIncome,
          ...formExpenses,
          ...formSavingsAndDebts,
          ...formAdditionalInformation,
          ...formHealth,
          ...formLivingPlace
        })
      : undefined;

  const [showModal, setShowModal] = React.useState(false);
  const [stepStatus, setStepStatus] = React.useState(arrStepsProgress);
  const [dataVal, setDataVal] = React.useState({
    status: '',
    paymentActivated: false,
    payed: false
  });
  const [isValidDocuments, setIsValidDocuments] = React.useState(false);

  // constants
  const statusCmp = { name: '', description: '' };

  // functions
  const goTo = (path: string) => {
    history.push(path);
  };

  const validateStatus = () => {
    if (dataVal.status === 'NO_STATUS') {
      return arrStepsProgress;
    }
    // empieza por pagos
    if (dataVal.status === 'PENDING_PAY') {
      statusCmp.name = 'Por pagar';
      return arrStepsProgress;
    }
    // empieza por formularios
    if (dataVal.status === 'PENDING_PROGRESS' && !dataVal.paymentActivated) {
      statusCmp.name = 'En proceso';
      return arrStepsProgress;
    }
    // validar que hay algun documento en el servidor
    if (dataVal.status === 'PENDING_PROGRESS' && documentsBse?.length > 0) {
      arrStepsProgress[0].complete = true;
      arrStepsProgress[1].complete = true;
      arrStepsProgress[2].disable = false;
      statusCmp.name = 'En proceso';
      return arrStepsProgress;
    }
    // pagado: paso 1 completo
    if (
      dataVal.status === 'PENDING_PROGRESS' &&
      dataVal.paymentActivated &&
      dataVal.payed // || (dataVal.paymentActivated && dataVal.payed)
    ) {
      arrStepsProgress[0].complete = true;
      statusCmp.name = 'En proceso';
      return arrStepsProgress;
    }
    if (
      dataVal.status === 'PENDING_ATTENTION' ||
      dataVal.status === 'PENDING_MODIFY'
    ) {
      arrStepsProgress[0].complete = true;
      arrStepsProgress[1].complete = true;
      arrStepsProgress[2].complete = true;
      arrStepsProgress[2].disable = false;
      arrStepsProgress[3].complete = true;
      arrStepsProgress[3].disable = false;
      arrStepsProgress[4].disable = false;
      statusCmp.name =
        dataVal.status === 'PENDING_ATTENTION' ? 'Pendiente' : 'En proceso';
      return arrStepsProgress;
    }
    if (
      dataVal.status === 'FINALIZED_SUCCESS' ||
      dataVal.status === 'FINALIZED_UNSUCCESS'
    ) {
      arrStepsProgress[0].complete = true;
      arrStepsProgress[1].complete = true;
      arrStepsProgress[2].complete = true;
      arrStepsProgress[2].disable = false;
      arrStepsProgress[3].complete = true;
      arrStepsProgress[3].disable = false;
      arrStepsProgress[4].disable = false;
      arrStepsProgress[4].complete = true;
      statusCmp.name =
        dataVal.status === 'FINALIZED_UNSUCCESS' ? 'No procede' : 'Procede';
      return arrStepsProgress;
    }

    return arrStepsProgress;
  };

  const updateStatus = (operationNbr: any) => {
    dispatch(
      procedureStatusActions.getStudentProcedureStatus(
        1013,
        parseInt(operationNbr, 10)
      )
    );
  };

  // handlers
  const handlerCompleteForm = (key: 'forms' | 'documents') => {
    if (key === 'forms') {
      history.push(
        routes.student.procedures.categories.scholarships.bse
          .procedureRegisterForms
      );
    }

    if (key === 'documents') {
      history.push(
        routes.student.procedures.categories.scholarships.bse
          .supportingDocuments
      );
    }
    window.scrollTo(0, 0);
  };

  const handlerNextStep = (key: 'forms' | 'documents') => {
    if (key === 'forms') {
      arrStepsProgress[0].complete = true;
      arrStepsProgress[1].complete = true;
      arrStepsProgress[2].disable = false;
      setStepStatus([...arrStepsProgress]);
    }
    if (key === 'documents') {
      arrStepsProgress[0].complete = true;
      arrStepsProgress[1].complete = true;
      arrStepsProgress[2].complete = true;
      arrStepsProgress[2].disable = false;
      arrStepsProgress[3].disable = false;
      setStepStatus([...arrStepsProgress]);
    }
  };

  const handlerStepAction = () => {
    setShowModal(true);
  };

  const handlerCloseModal = () => {
    if (isSuccessActivatePay) {
      goTo(routes.student.procedures.categories.scholarships.bse.progress);
    }
    setShowModal(false);
  };

  const handlerRedirect = () => {
    goTo(routes.student.payments.home);
  };

  const handlerActivatePayment = () => {
    dispatch(
      bseActivateOrderActions.activatePayOrder(
        procedure.currentRequestId,
        'UTP+Portal'
      )
    );
  };

  const handlerOkModal = () => {
    if (isSuccessActivatePay) {
      goTo(routes.student.payments.home);
    } else {
      handlerActivatePayment();
    }
  };

  const handleSend = () => {
    dispatch(processActions.processFormBse(String(idRequest)));
  };

  const handlerGoBack = () => {
    dispatch(bseActions.getFormBseClear());
    history.push(routes.student.procedures.home);
  };

  // effects
  useEffect(() => {
    XCheckpointManager.registerStart('BSE - Progress');
    if (!procedure) {
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.bse
        )
      );
    }
  }, []);

  useEffect(() => {
    if (procedureStatus && request?.statusBse) {
      dispatch(bseActions.getFormBse(idRequest));
      const { status, activatedPayment, payed } = request.statusBse;
      setDataVal({
        status,
        paymentActivated: activatedPayment,
        payed
      });

      if (
        [
          'PENDING_MODIFY',
          'PENDING_ATTENTION',
          'FINALIZED_UNSUCCESS',
          'FINALIZED_SUCCESS'
        ].includes(request?.statusBse?.status)
        // && !dataStateBse
      ) {
        dispatch(stateBseActions.getStateBse(5, idRequest));
      }
    }
  }, [procedureStatus]);

  useEffect(() => {
    setStepStatus(validateStatus());
  }, [dataVal, formBse]);

  useEffect(() => {
    if (isSuccessActivatePay) {
      updateStatus(idRequest);
    }
  }, [isSuccessActivatePay]);

  useEffect(() => {}, [stepStatus]);

  useEffect(() => {
    // updateInformation()
    if (isSuccessProcesBSE) {
      updateStatus(idRequest);
    }
  }, [isSuccessProcesBSE]);

  const [formDocumentIsCompleted, setFormDocumentIsCompleted] = useState(false);
  const [aditionalDocuments] = useState<any[]>([]);
  useEffect(() => {
    if (documentsBse) {
      setFormDocumentIsCompleted(
        !!(documentsBse as any[]).find((e: any) => e.idType === '1') &&
          !!(documentsBse as any[]).find((e: any) => e.idType === '7') &&
          !!(documentsBse as any[]).find((e: any) => e.idType === '9')
      );
    }
  }, [documentsBse]);

  const deleteUploadedFile = (ids: number[]) => {
    dispatch(deleteActions.deleteFileBse(ids));
  };

  const sendDocuments = (documents: any) => {
    // true para procesar agregar archivo en Estado Modify
    dispatch(uploadActions.uploadBseDocument(idRequest, documents, true));
  };

  const downloadUploadedFile = (path: string) => {
    dispatch(downloadActions.getUrlDocument(path, tokenDB));
  };

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.scholarships.bse.progress
        }${'?status=finalizado'}`
      );
    }
  }, [request]);

  useEffect(() => {
    if (request && formBse && !loadingFormBSE && !xcheckpointCalled) {
      XCheckpointManager.registerEnd('BSE - Progress');
      setXcheckpointCalled(true);
    }
  }, [request, formBse, loadingFormBSE]);
  return (
    <RegisterBaseView
      onBack={handlerGoBack}
      fromProgress
      loadingFormBSE={loadingFormBSE || isLoading}
      loadingPayment={loadingActivatePayOrder}
      successActivatePay={isSuccessActivatePay}
      procedure={procedure}
      handlerCompleteForm={handlerCompleteForm}
      handlerNextStep={handlerNextStep}
      formIsCompleted={formIsCompleted}
      formDocumentIsCompleted={formDocumentIsCompleted}
      showModal={showModal}
      handlerCloseModal={handlerCloseModal}
      handlerStepAction={handlerStepAction}
      handlerRedirect={handlerRedirect}
      handlerOkModal={handlerOkModal}
      handleSend={handleSend}
      loadingProcessBSE={loadingProcessBSE}
      stepStatus={stepStatus}
      dataValidate={dataVal}
      finalStateBse={objStateBse}
      // Estos son para el FileUpload
      deleteUploadedFile={(ids) => deleteUploadedFile(ids)}
      sendDocuments={(data) => sendDocuments(data)}
      downloadUploadedFile={downloadUploadedFile}
      aditionalDocuments={aditionalDocuments}
      //   formDocumentValid={formDocumentValid}
      isValidDocuments={isValidDocuments}
      setIsValidDocuments={setIsValidDocuments}
      requestSteps={procedureStatus?.steps || []}
      isLoadingUpdateFiles={isLoadingUpdateFiles}
      request={request}
    />
  );
};

export default ProgressBseController;
